export default {
  en: {
    ASSETS_TABLE_ROW_FORMAT: 'Format',
    ASSETS_TABLE_ROW_NAME: 'Name',
    ASSETS_TABLE_RECORDING: 'Recording',
    ASSETS_TABLE_LOADING: 'Loading Media',
    ASSETS_TABLE_EMPTY: 'No media in the account',
    ASSETS_REFERENCES_LOADING: 'Loading References',
    DELETE_ASSET_MODAL_ASSET_ASSOCIATION_TEXT: 'Please remove {assetName} from the following IVR Tree(s) before deleting it:',
    DELETE_ASSET_MODAL_TITLE: 'Delete Media',
    DELETE_ASSET_MODAL_VIEW_IVR: 'View IVR Tree',
    DELETE_ASSET_MODAL_ASSET_NONE_ASSOCIATION_TEXT: 'Media is not associated with any IVR trees.',
    DELETE_ASSET_SUCCESS: 'Media has been deleted',
    DELETE_ASSET_FAILURE: 'Unable to delete media',
    PREVIEW: 'Preview',
  }
};